import { LoginWithPasswordDocument } from 'graphql/generated/graphql';
import useAuth from './useAuth';

const useLogin = () => {
  const [login] = useAuth(LoginWithPasswordDocument);
  return login;
};

export default useLogin;
